import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import $ from 'jquery';

class ProductsItemPoint {
	constructor() {
		this.$container = $('.products_itempoint');
		if (!this.$container.length) return;

		this.initSwiper();
		this.initReadMore();
	}

	initSwiper() {
		this.swiper = new Swiper('.products_itempoint_swiper', {
			modules: [Navigation],
			initialSlide: 0,
			slidesPerView: 'auto',
			spaceBetween: 20,
			centeredSlides: false,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			navigation: {
				nextEl: '.products_itempoint_btn--next',
				prevEl: '.products_itempoint_btn--prev',
			},
			grabCursor: true,
			breakpoints: {
				// モバイル
				0: {
					slidesPerView: 'auto',
					spaceBetween: 10,
					centeredSlides: false,
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0,
				},
				// タブレット以上
				768: {
					slidesPerView: 'auto',
					spaceBetween: 20,
					centeredSlides: false,
					slidesOffsetBefore: 0,
					slidesOffsetAfter: 0,
				},
			},
		});
	}

	initReadMore() {
		$('.products_itempoint_slide_readmore').on('click', function () {
			const $button = $(this);
			const $accordion = $button.closest('.products_itempoint_slide_accordion');
			const $hidden = $accordion.find('.products_itempoint_slide_hidden');
			const $icon = $button.find('.icon');
			const $text = $button.find('.text');

			$hidden.slideToggle(300, function () {
				if ($hidden.is(':visible')) {
					$icon.text('−');
					$text.text('close');
					$button.addClass('is-active');
				} else {
					$icon.text('+');
					$text.text('read more');
					$button.removeClass('is-active');
				}
			});
		});
	}
}

$(() => {
	new ProductsItemPoint();
});

export default ProductsItemPoint;
